export default __webpack_public_path__ + "static/media/logo_spotter-login.05263078.png";